import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import About from "@/components/site/About";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";
import StickyCallBar from "@/components/site/StickyCallBar";
import ServiceDetail from "@/pages/ServiceDetail";

const HomePage = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="home-page" className="bg-[var(--rr-bg)] text-[var(--rr-text)] font-body">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Gallery />
        <About />
        <Reviews />
        <QuoteForm />
      </main>
      <Footer />
      <StickyCallBar />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      {/* Global SVG filter — keys white background out of the logo image */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <filter id="rr-remove-white" x="0" y="0" width="1" height="1">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      -0.6 -0.6 -0.6 0 1.5"
            />
          </filter>
        </defs>
      </svg>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
